export { SearchContentSettings } from "./SearchContentSettings.component";
